import React from 'react';
interface IconProps {
  className?: string;
}
export const RoofIcon = ({
  className = ''
}: IconProps) => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" className={className} data-id="element-65">
    <path d="M3 10l9-7 9 7" data-id="element-66" />
    <path d="M4 10v10a1 1 0 001 1h14a1 1 0 001-1V10" data-id="element-67" />
    <path d="M9 21v-6a2 2 0 012-2h2a2 2 0 012 2v6" data-id="element-68" />
  </svg>;
export const LeadIcon = ({
  className = ''
}: IconProps) => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" className={className} data-id="element-69">
    <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07 19.5 19.5 0 01-6-6 19.79 19.79 0 01-3.07-8.67A2 2 0 014.11 2h3a2 2 0 012 1.72 12.84 12.84 0 00.7 2.81 2 2 0 01-.45 2.11L8.09 9.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45 12.84 12.84 0 002.81.7A2 2 0 0122 16.92z" data-id="element-70" />
    <path d="M14.05 2a9 9 0 018 7.94" data-id="element-71" />
    <path d="M14.05 6A5 5 0 0118 10" data-id="element-72" />
  </svg>;
export const CompeteIcon = ({
  className = ''
}: IconProps) => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" className={className} data-id="element-73">
    <path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2" data-id="element-74" />
    <circle cx="9" cy="7" r="4" data-id="element-75" />
    <path d="M23 21v-2a4 4 0 00-3-3.87" data-id="element-76" />
    <path d="M16 3.13a4 4 0 010 7.75" data-id="element-77" />
    <path d="M18 14l-4-4 4-4" data-id="element-78" />
  </svg>;
export const StormIcon = ({
  className = ''
}: IconProps) => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" className={className} data-id="element-79">
    <path d="M17.5 19H9a7 7 0 116.71-9h1.79a4.5 4.5 0 110 9Z" data-id="element-80" />
    <path d="M13 14l-2 4h4l-2 4" data-id="element-81" />
  </svg>;
export const CalendarEmptyIcon = ({
  className = ''
}: IconProps) => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" className={className} data-id="element-82">
    <rect x="3" y="4" width="18" height="18" rx="2" ry="2" data-id="element-83" />
    <line x1="16" y1="2" x2="16" y2="6" data-id="element-84" />
    <line x1="8" y1="2" x2="8" y2="6" data-id="element-85" />
    <line x1="3" y1="10" x2="21" y2="10" data-id="element-86" />
    <line x1="10" y1="14" x2="14" y2="18" data-id="element-87" />
    <line x1="14" y1="14" x2="10" y2="18" data-id="element-88" />
  </svg>;
export const MarketingIcon = ({
  className = ''
}: IconProps) => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" className={className} data-id="element-89">
    <path d="M11 11.5l-3 3-3-3 3-3" data-id="element-90" />
    <path d="M11 11.5L21 21" data-id="element-91" />
    <path d="M21 3l-6 6" data-id="element-92" />
    <path d="M21 3v6" data-id="element-93" />
    <path d="M21 3h-6" data-id="element-94" />
  </svg>;
export const TargetPrecisionIcon = ({
  className = ''
}: IconProps) => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" className={className} data-id="element-95">
    <circle cx="12" cy="12" r="10" data-id="element-96" />
    <circle cx="12" cy="12" r="6" data-id="element-97" />
    <circle cx="12" cy="12" r="2" data-id="element-98" />
    <path d="M12 2v4" data-id="element-99" />
    <path d="M12 18v4" data-id="element-100" />
    <path d="M2 12h4" data-id="element-101" />
    <path d="M18 12h4" data-id="element-102" />
  </svg>;
export const AuthorityBadgeIcon = ({
  className = ''
}: IconProps) => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" className={className} data-id="element-103">
    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" data-id="element-104" />
    <path d="M9 12l2 2 4-4" data-id="element-105" />
  </svg>;
export const AutomationIcon = ({
  className = ''
}: IconProps) => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" className={className} data-id="element-106">
    <path d="M12 2v2" data-id="element-107" />
    <path d="M12 20v2" data-id="element-108" />
    <path d="M4.93 4.93l1.41 1.41" data-id="element-109" />
    <path d="M17.66 17.66l1.41 1.41" data-id="element-110" />
    <path d="M2 12h2" data-id="element-111" />
    <path d="M20 12h2" data-id="element-112" />
    <path d="M4.93 19.07l1.41-1.41" data-id="element-113" />
    <path d="M17.66 6.34l1.41-1.41" data-id="element-114" />
    <circle cx="12" cy="12" r="4" data-id="element-115" />
    <path d="M12 10l-1 2h2l-1 2" data-id="element-116" />
  </svg>;
export const GrowthIcon = ({
  className = ''
}: IconProps) => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" className={className} data-id="element-117">
    <path d="M3 3v18h18" data-id="element-118" />
    <path d="M18 9l-5 5-4-4-6 6" data-id="element-119" />
    <path d="M18 9h-5" data-id="element-120" />
    <path d="M18 9v5" data-id="element-121" />
  </svg>;
export const CostDownIcon = ({
  className = ''
}: IconProps) => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" className={className} data-id="element-122">
    <line x1="12" y1="1" x2="12" y2="23" data-id="element-123" />
    <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" data-id="element-124" />
    <path d="M16 19l-4 4-4-4" data-id="element-125" />
  </svg>;
export const CalendarFullIcon = ({
  className = ''
}: IconProps) => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" className={className} data-id="element-126">
    <rect x="3" y="4" width="18" height="18" rx="2" ry="2" data-id="element-127" />
    <line x1="16" y1="2" x2="16" y2="6" data-id="element-128" />
    <line x1="8" y1="2" x2="8" y2="6" data-id="element-129" />
    <line x1="3" y1="10" x2="21" y2="10" data-id="element-130" />
    <path d="M8 14l2 2 4-4" data-id="element-131" />
  </svg>;
export const GuaranteeShieldIcon = ({
  className = ''
}: IconProps) => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" className={className} data-id="element-132">
    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" data-id="element-133" />
    <text x="12" y="15" fontSize="8" fontWeight="bold" textAnchor="middle" fill="currentColor" stroke="none" data-id="element-134">
      30
    </text>
  </svg>;
export const CheckIcon = ({
  className = ''
}: IconProps) => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className} data-id="element-135">
    <polyline points="20 6 9 17 4 12" data-id="element-136" />
  </svg>;